import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-arrow-left-icon',
  templateUrl: 'arrow-left-icon.component.html'
})
export class ArrowLeftIconComponent {
  constructor() {}
}
